import { AxiosInstance, AxiosResponse } from "axios"

export interface CancellationSummaryData {
  title: string
  description: string
  titleIcon: string
  totalPaidBeforeServiceFee: number
  serviceFee: number
  totalPaidAmount: number
  refundableAmount: number
  refundablePercentage: number
  cancellationFee: number
  totalRefundableAmount: number
  confirmationPageTitle: string
  cancel_anyway_description: string
  serviceFeeToggleText: string
  is_eligible_for_cancellation: boolean
  promoCodeAmount?: number
  travellerInsurance?: number
  totalRefundablePromoAmount?: number
  cancel_anyway_button_title?: string
  model_title?: string
  insuranceTooltipMessage?: string
  insuranceExcluded?: boolean
  bookingCancelWithin24Hours?: boolean
  refundableServiceFee?: number
  refundableCreditAmount?: number
  totalCreditAmount?: number
}

export interface GetCancellationSummaryResponse extends AxiosResponse {
  data: {
    data: CancellationSummaryData
  }
}

export function getCancellationSummaryAPI(
  axiosInstance: AxiosInstance,
  bookingNo: string,
  reason: string,
): Promise<GetCancellationSummaryResponse> {
  return axiosInstance({
    method: "get",
    url: `/booking/cancellation-summary`,
    params: {
      bookingNo,
      reason,
    },
  }) as Promise<GetCancellationSummaryResponse>
}
